module.exports = __webpack_public_path__ + "files/d327af9dd35a53c14450188dbfba1153.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/sourcesanspro-italic-webfont.eot
 ** module id = 432
 ** module chunks = 0
 **/